import { ShipmentItem } from '@/api/shipments/types';

export const GET_SHIPMENT_DETAILS_QUERY = 'GET_SHIPMENT_DETAILS_QUERY';

export type UseShipmentDetailsQueryProps = {
  shipmentId?: string;
};

export type UseUpdateShipmentDetailsQueryProps = {
  shipmentId?: string;
  data: Partial<ShipmentItem>;
};
